import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-play-circle-fill text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">久久在线观看</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              久久在线观看为您提供海量高清视频资源，电影、电视剧、综艺、动漫应有尽有，无需下载即可流畅播放，随时随地享受极致视觉体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">视频分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快捷链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </div>
                <span>contact@jiujiuzaixian.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </div>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line"></i>
                </div>
                <span>北京市朝阳区望京SOHO T1</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; {new Date().getFullYear()} 久久在线观看 版权所有 | 久久在线观看高清视频平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500/80 transition-colors cursor-pointer">
              <i className="ri-wechat-line text-sm text-foreground-300"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500/80 transition-colors cursor-pointer">
              <i className="ri-weibo-line text-sm text-foreground-300"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500/80 transition-colors cursor-pointer">
              <i className="ri-bilibili-line text-sm text-foreground-300"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}